import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './sectionStyles.css';



AOS.init({
  duration: 1000,
  easing: 'ease-in-out',
});

ReactDOM.createRoot(document.getElementById('root')).render(<App />);

reportWebVitals();
